import { useState, useEffect } from 'react';
import { headerNav } from '@/mocks/homeData';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
            className="flex items-center gap-2 group"
          >
            <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-movie-2-line text-lg md:text-xl text-background-50"></i>
            </span>
            <span className="text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap">
              爱豆影视
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {headerNav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-400 rounded-lg hover:bg-background-100/80 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {item.title}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#media"
              onClick={(e) => { e.preventDefault(); handleNavClick('#media'); }}
              className="px-4 py-2 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              开始追剧
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100/80 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            {headerNav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-400 hover:bg-background-100/80 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {item.title}
              </a>
            ))}
            <a
              href="#media"
              onClick={(e) => { e.preventDefault(); handleNavClick('#media'); }}
              className="mt-2 px-3 py-3 text-sm font-medium text-center text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              开始追剧
            </a>
          </div>
        </div>
      )}
    </header>
  );
}